import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { MenuItem } from '@mui/material'
import MuiSelectWrapper from 'gui/components/common/MuiSelect'
import { getLanguageOptionsSupported } from 'services/languages'
import './index.scss'

/**
 * Language select ccomponent
 * @param {Object} props The props
 * @param {String} props.onChange An options onChange funciton
 * @param {String} props.value The value
 * @param {String} props.label The label
 * @param {String} props.name The DOM element name
 * @param {String} props.className The classname
 * @param {String} props.defaultValue The default value
 * @param {String} props.required When true the value is required
 * @param {String} props.id The DOM element id
 * @param {Boolean} props.disabled When true component is disabled
 * @param {import('immutable').List|import('immutable').Set} props.excludeLanguages
 *   A list or set of excluded languages
 */
export default function LanguageSelect (props) {
  const {
    className,
    defaultValue,
    disabled,
    excludeLanguages,
    id,
    label,
    name,
    onChange,
    placeholder,
    required,
    value,
  } = props
  let options = getLanguageOptionsSupported()
  if (excludeLanguages) {
    options = options.filter((v) => !excludeLanguages.includes(v.get('value')))
  }
  return (
    <MuiSelectWrapper
      id={id}
      label={label}
      className={className}
      name={name}
      onChange={onChange}
      value={value || defaultValue || ''}
      required={required}
      disabled={disabled}
    >
      {placeholder && <MenuItem value="">{placeholder}</MenuItem>}
      {options.map((option) => (
        <MenuItem value={option.get('value')} key={`language-${option.get('value')}`}>
          {option.get('label')}
        </MenuItem>
      ))}
    </MuiSelectWrapper>
  )
}

LanguageSelect.propTypes = {
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  excludeLanguages: PropTypes.oneOfType([ImmutablePropTypes.list, ImmutablePropTypes.set]),
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.string,
}

LanguageSelect.defaultProps = {
  placeholder: 'Please select a language',
  label: 'Language',
  name: 'language',
}
